import * as React from 'react';
import Box from '@mui/material/Box';

/** 確定デザインの .container（最大 1120px / 左右 48px・SP 24px）に対応する内枠。 */
export const containerSx = {
  maxWidth: 1120,
  mx: 'auto',
  px: { xs: 3, sm: 6 },
  width: '100%',
};

const backgrounds = {
  paper: { bg: 'paper', color: 'sumi' },
  kinari: { bg: 'kinari', color: 'sumi' },
  sumi: { bg: 'sumi', color: '#ffffff' },
  sumiDeep: { bg: 'sumiDeep', color: 'rgba(255,255,255,.85)' },
  green: { bg: 'green', color: '#ffffff' },
};

/**
 * 背景色の切り替えと縦padding（PC 120px / SP 80px）でセクションを区切る共通ラッパ。
 * mt/mb による巨大マージンは使わない。
 */
function Section({ bg = 'paper', py = { xs: 10, sm: 15 }, component = 'section', sx, children, ...other }) {
  const tone = backgrounds[bg] || backgrounds.paper;

  return (
    <Box
      component={component}
      sx={{
        bgcolor: (theme) => theme.palette[tone.bg] || tone.bg,
        color: (theme) => theme.palette[tone.color] || tone.color,
        py,
        ...sx,
      }}
      {...other}
    >
      <Box sx={containerSx}>{children}</Box>
    </Box>
  );
}

export default Section;
